module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "edit-developer-work-history"
    }
  }, [_c('div', {
    staticClass: "work-history edit-container"
  }, [_vm._l((_vm.formData.workHistory), function(workItem, index) {
    return _c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "set"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (workItem.place),
        expression: "workItem.place"
      }],
      class: [{
        invalid: workItem.place.trim() === ''
      }],
      attrs: {
        "type": "text",
        "placeholder": "Company"
      },
      domProps: {
        "value": (workItem.place)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          workItem.place = $event.target.value
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (workItem.title),
        expression: "workItem.title"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Position"
      },
      domProps: {
        "value": (workItem.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          workItem.title = $event.target.value
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (workItem.start),
        expression: "workItem.start"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Start Date"
      },
      domProps: {
        "value": (workItem.start)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          workItem.start = $event.target.value
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (workItem.end),
        expression: "workItem.end"
      }],
      attrs: {
        "type": "text",
        "placeholder": "End Date"
      },
      domProps: {
        "value": (workItem.end)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          workItem.end = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "button small-button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeWorkHistory(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa-trash fas"
    })]), _vm._v(" "), (index > 0) ? _c('button', {
      staticClass: "button small-button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.moveWorkHistoryUp(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa-arrow-up fas"
    })]) : _vm._e(), _vm._v(" "), (index !== _vm.formData.workHistory.length - 1) ? _c('button', {
      staticClass: "button small-button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.moveWorkHistoryDown(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa-arrow-down fas"
    })]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "set container"
  }, [_c('button', {
    staticClass: "button small-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addWorkHistory($event)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.allEntriesAreValid()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitChanges($event)
      }
    }
  }, [_vm._v("Save")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-445a7a82!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Developer/Widgets/EditDeveloperWorkHistory.vue
// module id = 863
// module chunks = 2